import { takeEvery } from "redux-saga/effects";
import {
  FETCH_EVENT_LIST,
  FETCH_EVENT_DETAILS,
  FETCH_EVENT_TYPES,
  FETCH_EVENT_PRODUCTS,
  EVENT_SELECTED,
  RECORD_STREAM_ACTIVITY
} from "../../state/events/constants";
import fetchList from "./fetchList";
import fetchDetails from "./fetchDetails";
import fetchEventTypes from "./fetchEventTypes";
import fetchEventProducts from "./fetchEventProducts";
import recordStreamActivity from "./recordStreamActivity";

function* events() {
  yield takeEvery(FETCH_EVENT_LIST, fetchList);
  yield takeEvery(FETCH_EVENT_PRODUCTS, fetchEventProducts);
  yield takeEvery(FETCH_EVENT_DETAILS, fetchDetails);
  yield takeEvery(FETCH_EVENT_TYPES, fetchEventTypes);
  yield takeEvery(EVENT_SELECTED, fetchDetails);
  yield takeEvery(RECORD_STREAM_ACTIVITY, recordStreamActivity);
}

export default events;
